import React from "react";

export const RadioCardGroup = ({
  options,
  value,
  onChange,
  disabled,
}: {
  options: { label: string; value: any }[];
  value?: any;
  onChange?: (val: any) => void;
  disabled?: boolean;
}) => {
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
      {options.map((opt) => {
        const isSelected = value === opt.value;
        const isDisabled = disabled;
        return (
          <div
            key={opt.value}
            onClick={() => {
              if (!isDisabled && onChange && !isSelected) {
                onChange(opt.value);
              }
            }}
            style={{
              padding: "10px 16px",
              border: `1px solid ${isSelected ? (isDisabled ? "#d9d9d9" : "#B79A68") : "#d9d9d9"}`,
              borderRadius: "8px",
              cursor: isDisabled ? "not-allowed" : "pointer",
              backgroundColor: isSelected ? (isDisabled ? "#f5f5f5" : "#B79A68") : (isDisabled ? "#f5f5f5" : "#fff"),
              color: isSelected ? (isDisabled ? "#a6a6a6" : "#fff") : (isDisabled ? "#a6a6a6" : "#000"),
              fontWeight: isSelected ? 600 : 400,
              transition: "all 0.2s",
              flex: "1 1 auto",
              textAlign: "center",
              userSelect: "none",
              opacity: isDisabled ? 0.6 : 1,
            }}
          >
            {opt.label}
          </div>
        );
      })}
    </div>
  );
};

export const CheckboxCardGroup = ({
  options,
  value = [],
  onChange,
  disabled,
  maxSelection,
}: {
  options: { label: string; value: any }[];
  value?: any[];
  onChange?: (val: any[]) => void;
  disabled?: boolean;
  maxSelection?: number;
}) => {
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
      {options.map((opt) => {
        const isSelected = value.includes(opt.value);
        const isAtMax = maxSelection ? value.length >= maxSelection && !isSelected : false;
        const isDisabled = disabled || isAtMax;
        
        return (
          <div
            key={opt.value}
            onClick={() => {
              if (!isDisabled && onChange) {
                if (isSelected) {
                  onChange(value.filter((v) => v !== opt.value));
                } else {
                  onChange([...value, opt.value]);
                }
              }
            }}
            style={{
              padding: "10px 16px",
              border: `1px solid ${isSelected ? (isDisabled ? "#d9d9d9" : "#B79A68") : "#d9d9d9"}`,
              borderRadius: "8px",
              cursor: isDisabled ? "not-allowed" : "pointer",
              backgroundColor: isSelected ? (disabled ? "#f5f5f5" : "#B79A68") : (disabled ? "#f5f5f5" : "#fff"),
              color: isSelected ? (disabled ? "#a6a6a6" : "#fff") : (disabled ? "#a6a6a6" : "#000"),
              fontWeight: isSelected ? 600 : 400,
              transition: "all 0.2s",
              flex: "1 1 auto",
              textAlign: "center",
              userSelect: "none",
              opacity: isDisabled ? 0.6 : 1,
            }}
          >
            {opt.label}
          </div>
        );
      })}
    </div>
  );
};
